'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EmployerStats;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _HalfRichText = require('shared/modules/HalfRichText');

var _HalfRichText2 = _interopRequireDefault(_HalfRichText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  {
    "type": "employer_stats",
    "employees": 250,
    "subsectors": [
      "insurance"
    ]
  }

  Specifically for the Employer page, this displays information about the employer,
  including its subsectors and employee numbers. Has the following required attributes:
  employees and subsectors.
 */

function EmployerStats(_ref) {
  var moduleClass = _ref.moduleClass,
      employees = _ref.employees,
      subsectors = _ref.subsectors;

  return _react2.default.createElement(
    'div',
    {
      className: 'type-employer_stats ' + moduleClass
    },
    _react2.default.createElement(_HalfRichText2.default, {
      title: 'Employees',
      content: '' + employees
    }),
    _react2.default.createElement(_HalfRichText2.default, {
      title: 'Sub-Sectors',
      content: subsectors.join(', ')
    })
  );
}
//import { Link } from 'react-router';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/EmployerStats/EmployerStats.jsx
// module id = 1157
// module chunks = 0